export default "__VITE_ASSET__e849bb10__"